//import { Page } from "./model/Page";
import { InputSingleValueString, InputOptional, InputType, UIElementHint, InputImage, InputSingleValueNumber, InputAction } from "../model/Element";
import { createMailLink, Flow } from '../FlowEngineAPI';

import { downloadPDFGeneric } from '../../pdf/PDFCreator';
import { Page } from "../model/Page";


// ==============================================================================================================================
//export interface Flow {
//    Pages: Page[]
//}

export function setLang(code: string) {
    return;
}

export function getLang(): string {
    return "en";
}


// ==============================================================================================================================
// https://portal.ktr.com/technic/technical_application/Pages/questionnaire_product.aspx

let flow: Flow = {
    name: "servo",
    label: "servo-selection",
    Pages: [
        new Page( {
            id:  "page1",
            name: "servokupplung_allgemein",
            label: "Fragebogen Auslegung der Servokupplung allgemein",
            url: "www.ktrpage.com/page1",
            isSelected:false,
            elements:[
                new InputOptional({
                    type: InputType.Optional,
                    name: "stoesse",
                    label: "Stöße",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["leicht","mittel","schwer"],
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "umgebungstemperatur",
                    label: "Umgebungstemperatur (°C)",
                    value: undefined,
                    isMandatory: true,
                    componentname:"",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "art_antrieb",
                    label: "Art der Antriebsseite",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["Getriebe","Drehgeber","Riemenantrieb"],
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "sonstiges",
                    label: "Sonstiges",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
            ],
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page2";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page2",
            name:"daten_antriebsseite",
            label:"Daten Antriebsseite",
            url:"www.ktrpage.com/page2",
            isSelected:false,
            elements:[
                new InputImage({
                    type: InputType.Image,
                    name: "Wellen",
                    label: "Übersicht Wellen",
                    value: "",
                    target: "wellen",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "torque_nominal",
                    label: "Nenndrehmoment an der Kupplung [Nm]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "torque_max",
                    label: "Max. Drehmoment an der Kupplung [Nm]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "speed_max",
                    label: "Max. Drehzahl [1/min]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "length_d1",
                    label: "d1 [mm]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                /*
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "tol_d1",
                    label: "d1 Toleranz",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                */
               new InputOptional({
                    type: InputType.Optional,
                    name: "tol_d1",
                    label: "Toleranz d1",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Combobox,
                    options:["H6","H7","h6","h7","K6","K7","k6","k7","L6","L7","l6","l7",]
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "length_l1",
                    label: "l1 [mm]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "mom_of_inertia_ja",
                    label: "Massenträgheitsmoment JA [kgm^2]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "dbse",
                    label: "DBSE [mm]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "mom_of_inertia_jl",
                    label: "Massenträgheitsmoment JL [kgm^2]",
                    value: undefined,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page99";   // Wellentyp
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page99",
            name:"Ergebnis",
            label:"Ergebnis",
            url:"www.ktrpage.com/page99",
            isSelected:false,
            showOverview: true,
            elements:[
                new InputImage({
                    type: InputType.Image,
                    name: "Wellen",
                    label: "Übersicht Wellen",
                    value: "",
                    target: "wellen",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Firma",
                    label: "Firma",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Anschrift",
                    label: "Anschrift",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Name",
                    label: "Name",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Telefon",
                    label: "Telefon",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Bemerkkung",
                    label: "Bemerkung",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Mail",
                    label: "Mail",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputAction({
                    type: InputType.Action,
                    name:"Send Mail",
                    label:"Send Mail",
                    value:"",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Button,
                    "onAction": () => {
                        let url: string = createMailLink("k.tebroke@ktr.com", "Auslegung für Verbrennungsmotoren");
                        window.location.href = url;
                        //window.open(url);
                    }
                }),
                new InputAction({
                    type: InputType.Action,
                    name:"Save PDF",
                    label:"Save PDF",
                    value:"",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Button,
                    "onAction": () => {
                        downloadPDFGeneric(flow.label);
                    }
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page99";
                return nextPage;
            }
        }),

        // ---------------------------------------------------------------------------------------------------------------
    ]
    };

export { flow };
